import classNames from 'classnames'
import * as React from 'react'
import {createSelector} from 'reselect'

import IconButton from '../../IconButton/IconButton'

import styles from './VirtualizedTreeExpandHandle.css'

type Props = {
  expanded?: boolean
  expandable: boolean
  indent: number
  className: string
  onClick?: () => unknown
  tabIndex?: number
}
const computeStyle = createSelector(
  (indent: number) => indent,
  indent => ({
    marginLeft: `${indent}px`,
  }),
)
function VirtualizedTreeExpandHandle({
  expanded,
  expandable,
  indent,
  className,
  onClick,
  tabIndex,
}: Props) {
  const style = computeStyle(indent)
  return expandable && onClick != null ? (
    <IconButton
      special
      title={expanded === true ? 'Collapse' : 'Expand'}
      style={style}
      className={classNames(styles.chevronButton, className)}
      iconWrapperClassName={styles.chevronIcon}
      icon={expanded === true ? 'chevron-down' : 'chevron-right'}
      onClick={onClick}
      tabIndex={tabIndex} // onMouseEnter={this.onChevronMouseEnter}
      // onMouseLeave={this.onChevronMouseLeave}
      data-test={expanded === true ? 'collapse-button' : 'expand-button'}
    />
  ) : (
    <span className={classNames(styles.fakeChevronButton, className)} style={style} />
  )
}
export default React.memo<Props>(VirtualizedTreeExpandHandle)
